import { GeneratedFile, ModelSelected, ResponseTimeAnalytics, SourceFile, SSEResponse, SSEResponseTypes } from '../models/websockets.types';
import { ConversationState } from '../state/store/chat/use-chat-store';
import { Attachment, FileGenerationStatus, MessageRole, SearchSource, Source, Mention } from 'features/chat/types/chat';
import { IamData } from 'features/iam/services/user-service';
import { DEFAULT_CONVERSATION_NAME } from './constants/chat-constants';

export const getUpdatedMessages = (SSEResponse: SSEResponse, currentConv: ConversationState) => {

  // console.log('SSEResponse in getUpdatedMessages---->', SSEResponse);
  if (!currentConv.messages) return [];

  const targetMessageId = SSEResponse.assistant_message_id
  const messageSenderId = SSEResponse.message_sender_id;
  
  if (!targetMessageId) {
    return [];
  }
  

  let messagesToWorkWith: typeof currentConv.messages = [...currentConv.messages];
  
  if (!currentConv.isGroupChat && messagesToWorkWith.length > 0  ) {
    const lastMessage = messagesToWorkWith[messagesToWorkWith.length - 1];
    const parentIds = SSEResponse.parent_ids;

    if(lastMessage.role === MessageRole.ASSISTANT){
      if(parentIds && parentIds.length > 0){
  
        const parentMsgIndex = messagesToWorkWith.findIndex(
          (msg) => parentIds.includes(msg.recordId) &&
            (msg.role === MessageRole.ASSISTANT)
        );
        if (parentMsgIndex !== -1) {
          const parentMsg = messagesToWorkWith[parentMsgIndex];
          const generationExists = parentMsg.generations.some(gen => gen.id === targetMessageId);
          
          if(!generationExists){
            // Check if targetMessageId already exists in any generation across all messages to avoid duplicates
            const targetIdExistsAnywhere = messagesToWorkWith.some(msg => 
              msg.generations.some(gen => gen.id === targetMessageId)
            );
            
            if (!targetIdExistsAnywhere) {
              // Update the last generation's id instead of creating a new one
              messagesToWorkWith = messagesToWorkWith.map((msg, index) => {
                if (index === parentMsgIndex) {
                  let updatedGenerations;
                  if (msg.generations.length > 0) {
                    // Update the last generation's id to targetMessageId
                    updatedGenerations = msg.generations.map((gen, genIndex) => {
                      if (genIndex === msg.generations.length - 1) {
                        return {
                          ...gen,
                          id: targetMessageId,
                          parentIds: parentIds,
                        };
                      }
                      return gen;
                    });
                  } else {
                    // No generations exist, create a new one
                    updatedGenerations = [
                      {
                        id: targetMessageId,
                        content: '',
                        createdDate: Date.now(),
                        parentIds: parentIds,
                      }
                    ];
                  }
                  return {
                    ...msg,
                    generations: updatedGenerations,
                    activeGenerationIndex: updatedGenerations.length - 1,
                  };
                }
                return msg;
              });
            } else {
              // targetMessageId already exists somewhere, find it and set activeGenerationIndex
              let foundMsgIndex = -1;
              let foundGenIndex = -1;
              for (let i = 0; i < messagesToWorkWith.length; i++) {
                const genIndex = messagesToWorkWith[i].generations.findIndex(gen => gen.id === targetMessageId);
                if (genIndex !== -1) {
                  foundMsgIndex = i;
                  foundGenIndex = genIndex;
                  break;
                }
              }
              if (foundMsgIndex !== -1 && foundGenIndex !== -1) {
                messagesToWorkWith = messagesToWorkWith.map((msg, index) => {
                  if (index === foundMsgIndex) {
                    return {
                      ...msg,
                      activeGenerationIndex: foundGenIndex,
                    };
                  }
                  return msg;
                });
              }
            }
          } else {
            // Generation exists, set activeGenerationIndex to that generation
            const generationIndex = parentMsg.generations.findIndex(gen => gen.id === targetMessageId);
            if (generationIndex !== -1) {
              messagesToWorkWith = messagesToWorkWith.map((msg, index) => {
                if (index === parentMsgIndex) {
                  return {
                    ...msg,
                    activeGenerationIndex: generationIndex,
                  };
                }
                return msg;
              });
            }
          }
        }
          
      }else{
    
          const needsRecordIdUpdate = lastMessage.recordId !== targetMessageId;
          const hasGenerationWithId = lastMessage.generations.some(gen => gen.id === targetMessageId);
          
          if (needsRecordIdUpdate || !hasGenerationWithId) {
            // Check if targetMessageId already exists in any generation across all messages to avoid duplicates
            const targetIdExistsAnywhere = messagesToWorkWith.some(m => 
              m.generations.some(gen => gen.id === targetMessageId)
            );
            
            messagesToWorkWith = messagesToWorkWith.map((msg, index) => {
              if (index === messagesToWorkWith.length - 1) {
                let updatedGenerations;
                let activeGenIndex: number | undefined;
                
                if (hasGenerationWithId) {
                  // Generation already exists in this message, keep all generations as is
                  updatedGenerations = msg.generations;
                  activeGenIndex = msg.generations.findIndex(gen => gen.id === targetMessageId);
                } else if (!targetIdExistsAnywhere) {
                  // targetMessageId doesn't exist anywhere, update the last generation's id
                  if (msg.generations.length > 0) {
                    updatedGenerations = msg.generations.map((gen, genIndex) => {
                      if (genIndex === msg.generations.length - 1) {
                        return {
                          ...gen,
                          id: targetMessageId,
                        };
                      }
                      return gen;
                    });
                    activeGenIndex = updatedGenerations.length - 1;
                  } else {
                    updatedGenerations = [
                      {
                        id: targetMessageId,
                        content: '',
                        createdDate: Date.now(),
                      }
                    ];
                    activeGenIndex = 0;
                  }
                } else {
                  // targetMessageId exists in another message, keep generations as is
                  updatedGenerations = msg.generations;
                }
                
                return {
                  ...msg,
                  recordId: targetMessageId,
                  generations: updatedGenerations,
                  ...(activeGenIndex !== undefined && { activeGenerationIndex: activeGenIndex }),
                };
              }
              return msg;
            });
          } else if (hasGenerationWithId) {
            // Generation exists and recordId is correct, just set activeGenerationIndex
            const genIndex = lastMessage.generations.findIndex(gen => gen.id === targetMessageId);
            if (genIndex !== -1) {
              messagesToWorkWith = messagesToWorkWith.map((msg, index) => {
                if (index === messagesToWorkWith.length - 1) {
                  return {
                    ...msg,
                    activeGenerationIndex: genIndex,
                  };
                }
                return msg;
              });
            }
          }
        }
      

    }
  }
  
  let assistantMsgIndex = messagesToWorkWith && messagesToWorkWith.findIndex((msg) => {
    if (msg.role !== MessageRole.ASSISTANT) return false;
    let found = false;
    for (const gen of msg.generations) {
      if (gen.id == targetMessageId) {
        found = true;
        break;
      }
    }
    return found;
  });



  if (assistantMsgIndex === -1 && messageSenderId) {
    const messageToUpdateIndex = messagesToWorkWith.findIndex((msg) => {
      if (msg.role !== MessageRole.ASSISTANT) return false;
      // Check if messageSenderId matches userRecordId
      return msg.userRecordId === messageSenderId;
    });

    if (messageToUpdateIndex !== -1) {
      // Update the message with recordId = targetMessageId and userRecordId = messageSenderId
      // Only update the LAST generation's id to targetMessageId (the placeholder)
      const messageToUpdate = messagesToWorkWith[messageToUpdateIndex];
      const lastGenIndex = messageToUpdate.generations.length - 1;
      messagesToWorkWith[messageToUpdateIndex] = {
        ...messageToUpdate,
        recordId: messageToUpdate.recordId, // Keep original recordId
        userRecordId: messageSenderId,
        generations: messageToUpdate.generations.map((gen, idx) => {
          if (idx === lastGenIndex) {
            return {
              ...gen,
              id: targetMessageId,
              content: "",
            };
          }
          return gen;
        }),
        activeGenerationIndex: lastGenIndex,
      };
      
      // Now find the message again - it should be found by generation id
      assistantMsgIndex = messagesToWorkWith.findIndex((msg) => {
        if (msg.role !== MessageRole.ASSISTANT) return false;
        let found = false;
        for (const gen of msg.generations) {
          if (gen.id == targetMessageId) {
            found = true;
            break;
          }
        }
        return found;
      });
    }
  }

  if (assistantMsgIndex === -1) return [];

  const updatedMessages = messagesToWorkWith;
  const existingMsg = updatedMessages[assistantMsgIndex];
  const existingGenerations = existingMsg.generations;
  let updatedGenerations;

  // console.log('SSEResponse in getUpdatedMessages', SSEResponse.type);

  if (
    SSEResponse.type == SSEResponseTypes.FILE_GENERATION_ON_PROGRESS ||
    SSEResponse.type == SSEResponseTypes.IMAGE_GENERATION_SUCCESS
  ) {
    let fileData: GeneratedFile;
    // console.log('SSEResponse.data in getUpdatedMessages', SSEResponse.data)
    if (typeof SSEResponse.data !== 'object' && typeof SSEResponse.data !== 'string')
      fileData = JSON.parse(SSEResponse.data) as GeneratedFile;
    else fileData = SSEResponse.data as GeneratedFile;
    const file: Attachment = {
      fileId: fileData.file_id,
      fileName: fileData.file_name,
      extension: fileData.file_type,
      sender: MessageRole.ASSISTANT,
      status: fileData.status as FileGenerationStatus,
    };
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        let found = false;
        if (SSEResponse.type == SSEResponseTypes.IMAGE_GENERATION_SUCCESS) {
          gen.generatedImages?.map((attachment) => {
            if (attachment.fileId === file.fileId) {
              attachment.status = file.status;
              found = true;
            }
          });
          if (!found) {
            (gen.generatedImages ??= []).push(file);
          }
        } else if (SSEResponse.type == SSEResponseTypes.FILE_GENERATION_ON_PROGRESS) {
          gen.attachments?.map((attachment) => {
            if (attachment.fileId === file.fileId) {
              attachment.status = file.status;
              found = true;
            }
          });
          if (!found) {
            (gen.attachments ??= []).push(file);
          }
        }
        if (fileData.message) {
          gen.content = fileData.message;
        }
        gen.HasFileGeneratedResponse = true;
        return gen;
      }
      return gen;
    });
  } else if (SSEResponse.type == SSEResponseTypes.CODE_EXECUTION_ARTIFACT) {
    // Handle artifact data structure with filename instead of file_name

    const artifactData = SSEResponse.data as any;
    const file: Attachment = {
      fileId: artifactData.file_id,
      fileName: artifactData.file_name,
      extension: artifactData.file_type,
      sender: MessageRole.ASSISTANT,
      status: FileGenerationStatus.COMPLETED, // Artifacts are typically completed when received
    };
    

    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        let found = false;
        gen.attachments?.map((attachment) => {
          if (attachment.fileId === file.fileId) {
            attachment.status = file.status;
            found = true;
          }
        });
        if (!found) {
          (gen.attachments ??= []).push(file);
        }
        gen.HasFileGeneratedResponse = true;
        return gen;
      }
      return gen;
    });
  } else if( 
    SSEResponse.type == SSEResponseTypes.RESPONSE_SOURCES
  ) {
    const rawSources = SSEResponse.data as SourceFile[];
    const sources: Source[] = rawSources.map((source: any) => ({
      fileId: source.file_id,
      fileName: source.file_name,
      chunks: [],
    }));
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          sources,
        };
      }
      return gen;
    });
  } else if(
    SSEResponse.type == SSEResponseTypes.SEARCH_SOURCES
  ){
    const searchSources = SSEResponse.data as SearchSource[];
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          searchSources,
          isSearchSourcesShow: true,
        };
      }
      return gen;
    });
  } else if (
    SSEResponse.type == SSEResponseTypes.IMAGE_GENERATION_STARTED 
  ) {
    const content = SSEResponse.data as string;
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          content: gen.content + (gen.content ? '\n' : '') + content,
          HasFileGeneratedResponse: true,
        };
      }
      return gen;
    });
  } else if(SSEResponse.type == SSEResponseTypes.IMAGE_GENERATION_FAILED) {
    const content = SSEResponse.data as string;
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          content: content,
          HasFileGeneratedResponse: true,
        };
      }
      return gen;
    });
  } else if (
     SSEResponse.type == SSEResponseTypes.FILE_GENERATION_STARTED ||
     SSEResponse.type == SSEResponseTypes.FILE_GENERATION_FAILED ||
     SSEResponse.type == SSEResponseTypes.FILE_GENERATION_SUCCESS
  ) {
     const content = SSEResponse.data as string;
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          content: content,
          HasFileGeneratedResponse: true,
          isAnalyzing: true,
          isAnalyzed: false,
        };
      }
      return gen;
    });
  } else if (SSEResponse.type == SSEResponseTypes.CONTEXT_WINDOW_EXCEEDED ||
    SSEResponse.type == SSEResponseTypes.SERVER_ERROR ||
    SSEResponse.type == SSEResponseTypes.IMAGE_GENERATION_LIMIT_EXCEEDED
  ) {
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          content: '',
          isAnalyzing: false, 
          isAnalyzed: false,
          isThinking: false,
          thinkContent: '',
        };
      }
      return gen;
    });
  } else if(SSEResponse.type == SSEResponseTypes.ASSISTANT_REQUEST_PROCESSING_STARTED) {
    // No longer creating MODEL_THINKING messages - skip this event
    return updatedMessages;
  } else if(SSEResponse.type == SSEResponseTypes.LLM_THINKING) {
    const content = SSEResponse.data as string;
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    console.log('targetMessageId in SSEResponseTypes.LLM_THINKING', targetMessageId,"content",content);
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          thinkContent: (gen.thinkContent ?? '') + content,
          isThinking: true
        };
      }
      return gen;
    });
  } else if(SSEResponse.type == SSEResponseTypes.SEARCH_RESPONSE) {
    const content = SSEResponse.data as string;
    const finishedThinking = content.includes('</think>');
    const isDynamicThinking = content.includes('<think>');

    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {

        if(gen.isThinking && !finishedThinking) {
          return {
            ...gen,
            thinkContent: (gen.thinkContent ?? '') + content,
            isSearchSourcesShow: true,
          };
        }

        if(gen.isThinking && finishedThinking) {
          return {
            ...gen,
            isThinking: false,
            isSearchSourcesShow: true,
          };
        }

        if(!gen.isThinking && finishedThinking) {
          const content_splits = content.split('</think>');
          return {
            ...gen,
            thinkContent: gen.content + content_splits[0],
            content: content_splits[1],
            isThinking: false
          };
        }

        if(!gen.isThinking && isDynamicThinking) {
          return {
            ...gen,
            isThinking: true,
            thinkContent: content.replace('<think>', ''),
          };
        }

        return {
          ...gen,
          content: (gen.content ?? '') + content,
          isSearchSourcesShow: true,
        };
      }
      return gen;
    });
  } else if(SSEResponse.type == SSEResponseTypes.CODE_EXECUTION_STARTED) {
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          isAnalyzing: true,
        };
      }
      return gen;
    });
  } else if(SSEResponse.type == SSEResponseTypes.CODE_EXECUTION_STEP) {
    const stepData = SSEResponse.data as any;
    
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          content: (gen.content ?? ''),
          isAnalyzing: true,  // Set analyzing to true when CODE_EXECUTION_STEP comes in
          isAnalyzed: false,  // Set analyzed to false when CODE_EXECUTION_STEP comes in
          codeExecutionSteps: [...(gen.codeExecutionSteps ?? []), stepData],
        };
      }
      return gen;
    });
   } else if(SSEResponse.type == SSEResponseTypes.RESPONSE_TIME_ANALYTICS) {
    const responseTimeData = SSEResponse.data as ResponseTimeAnalytics;
    
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          responseAnalytics: responseTimeData,
        };
      }
      return gen;
    });
   } else if(SSEResponse.type == SSEResponseTypes.MODEL_SELECTED) {
    const modelData = SSEResponse.data as ModelSelected;
    
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          usedModelId: modelData.selected_model
        };
      }
      return gen;
    });
   } else if(SSEResponse.type == SSEResponseTypes.STREAM_CANCELLED) {
    // Use targetMessageId instead of streamingAssistantMessageId to support concurrent streams
    const targetMessageId = SSEResponse.assistant_message_id || currentConv.streamingAssistantMessageId;
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        return {
          ...gen,
          isThinking: false
        };
      }
      return gen;
    });
   } else {
    const content = SSEResponse.data as string;
    // console.log('content in utils', existingGenerations)
    // No longer handling MODEL_THINKING conversion - messages are created as ASSISTANT directly
    
    // targetMessageId is already defined at the top of the function
    updatedGenerations = existingGenerations.map((gen) => {
      if (gen.id === targetMessageId) {
        const updatedGen = {
          ...gen,
          content: (gen.content ?? '') + content,
        };
        
        // If this is LLM_ANSWER, mark it as analyzed and not analyzing only if there were code execution steps
        if (SSEResponse.type === SSEResponseTypes.LLM_ANSWER) {
          updatedGen.isAnalyzing = false;
          // Only set isAnalyzed to true if there were CODE_EXECUTION_STEP responses
          updatedGen.isAnalyzed = !!(gen.codeExecutionSteps && gen.codeExecutionSteps.length > 0);
        }
        
        return updatedGen;
      }
      return gen;
    });
  }
  updatedMessages[assistantMsgIndex] = {
    ...existingMsg,
    generations: updatedGenerations ? updatedGenerations : existingGenerations,
  };
  return updatedMessages;
};

export function isValidUrl(input: string) {
  if (!input) return false;
  const match = String(input)
    .trim()
    .match(/^https?:\/\/[^\s<>"'()]+$/i);
  if (!match) return false;
  const candidate = match[0].replace(/[.,;!?]+$/, '');
  try {
    const u = new URL(candidate);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}

export const placeHrefInContent = (content: string, searchSources: SearchSource[]): string => {
  /**
   * Matches both citation formats:
   * - ASCII: [1], [2], [3]  
   * - Unicode: 【1】,【2】,【3】
   * 
   * Regex breakdown:
   * (?:\[|【) - Non-capturing group: match [ OR 【
   * (\d+)     - Capture digits (citation number)
   * (?:\]|】) - Non-capturing group: match ] OR 】
   * (?!\()    - Negative lookahead: not followed by (
   */
  return content.replace(/(?:\[|【)(\d+)(?:\]|】)(?!\()/g, (match, numberStr) => {
    const index = parseInt(numberStr, 10) - 1; // markdown refs start at 1
    const source = index>=0 && index < searchSources.length ? searchSources[index] : null;
    const isValid = source && source.metadata?.url && isValidUrl(source.metadata.url);

    if (isValid) {
      return `[${numberStr}](${source.metadata.url})`;
    }

    // fallback: keep the original [number]
    // return match;
    return "";
  });
};

// ==================== Mention Utilities ====================

export const getMentionUserName = (mention: Mention): string => {
  if (!mention.user) return '';
  return `${mention.user.firstName}${mention.user.lastName ? ` ${mention.user.lastName}` : ''}`;
};

/**
 * Get the display name for a user from IamData
 */
export const getUserDisplayName = (user: IamData): string => {
  return `${user.firstName}${user.lastName ? ` ${user.lastName}` : ''}`;
};

/**
 * Find the position where text changed between two strings
 */
const findChangePosition = (oldText: string, newText: string): number => {
  const minLength = Math.min(oldText.length, newText.length);
  for (let i = 0; i < minLength; i++) {
    if (oldText[i] !== newText[i]) {
      return i;
    }
  }
  return minLength;
};

/**
 * Update mention positions when text changes
 * Returns updated mentions with corrected positions, removing invalid ones
 */
export const updateMentionPositions = (
  mentions: Mention[],
  oldText: string,
  newText: string
): Mention[] => {
  if (mentions.length === 0) return mentions;

  const lengthDiff = newText.length - oldText.length;
  const changeStart = lengthDiff !== 0 ? findChangePosition(oldText, newText) : 0;

  return mentions
    .map((mention) => {
      const expectedText = getMentionUserName(mention);

      // Check if mention is out of bounds
      if (mention.start >= newText.length || mention.end > newText.length) {
        return null;
      }

      // Check if mention text still matches at current position
      const currentMentionText = newText.substring(mention.start, mention.end);

      if (expectedText && currentMentionText === expectedText) {
        // Mention text matches - adjust position if change occurred before it
        if (lengthDiff !== 0 && changeStart < mention.start) {
          const newStart = mention.start + lengthDiff;
          const newEnd = mention.end + lengthDiff;

          if (newStart < 0 || newEnd > newText.length) {
            return null;
          }

          return { ...mention, start: newStart, end: newEnd };
        }

        // Change occurred within or after mention - mention might be corrupted
        if (changeStart >= mention.start && changeStart < mention.end) {
          // Try to find the mention text nearby
          const searchStart = Math.max(0, mention.start - 10);
          const foundIndex = newText.indexOf(expectedText, searchStart);

          if (foundIndex !== -1) {
            return {
              ...mention,
              start: foundIndex,
              end: foundIndex + expectedText.length,
            };
          }
          return null;
        }

        return mention;
      }

      // Mention text doesn't match - try to find it nearby
      if (expectedText) {
        const searchStart = Math.max(0, mention.start - 20);
        const searchEnd = Math.min(newText.length, mention.end + 20);
        const searchArea = newText.substring(searchStart, searchEnd);
        const foundIndex = searchArea.indexOf(expectedText);

        if (foundIndex !== -1) {
          const newStart = searchStart + foundIndex;
          const newEnd = newStart + expectedText.length;

          if (newStart >= 0 && newEnd <= newText.length) {
            return { ...mention, start: newStart, end: newEnd };
          }
        }
      }

      return null;
    })
    .filter((mention): mention is Mention => mention !== null)
    .sort((a, b) => a.start - b.start);
};

/**
 * Detect if @ trigger should open mention dropdown
 */
export interface MentionTriggerInfo {
  shouldOpen: boolean;
  startPosition: number;
  searchQuery: string;
}

export const detectMentionTrigger = (
  text: string,
  cursorPosition: number
): MentionTriggerInfo | null => {
  const textBeforeCursor = text.substring(0, cursorPosition);
  const lastAtIndex = textBeforeCursor.lastIndexOf('@');

  if (lastAtIndex === -1) {
    return null;
  }

  const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1);
  const textBeforeAt = textBeforeCursor.substring(0, lastAtIndex);
  const charBeforeAt = lastAtIndex > 0 ? textBeforeAt[textBeforeAt.length - 1] : '';
  const hasSpaceBeforeAt = lastAtIndex === 0 || charBeforeAt === ' ' || charBeforeAt === '\n';

  // Check if it's an email address
  const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const textAroundAt = textBeforeAt.slice(-50) + '@' + textAfterAt.slice(0, 50);
  const isEmail = emailPattern.test(textAroundAt);

  const hasSpaceAfterAt = textAfterAt.includes(' ');
  const hasNewlineAfterAt = textAfterAt.includes('\n');

  if (hasSpaceBeforeAt && !isEmail && !hasSpaceAfterAt && !hasNewlineAfterAt) {
    return {
      shouldOpen: true,
      startPosition: lastAtIndex,
      searchQuery: textAfterAt,
    };
  }

  return null;
};

/**
 * Adjust mention positions for markdown conversion (newlines become "  \n")
 */
export const adjustMentionsForMarkdown = (
  mentions: Mention[],
  originalMessage: string,
  cleanedMessage: string,
  leadingWhitespaceLength: number
): Mention[] => {
  if (mentions.length === 0) return mentions;

  return mentions
    .map((mention) => {
      const expectedText = getMentionUserName(mention);

      if (!expectedText) {
        console.warn('Mention has no user data:', mention);
        // Still try to adjust position
        let adjustedStart = Math.max(0, mention.start - leadingWhitespaceLength);
        let adjustedEnd = Math.min(cleanedMessage.length, mention.end - leadingWhitespaceLength);

        const newlinesBefore = (originalMessage.substring(0, mention.start).match(/\n/g) || []).length;
        const newlinesIn = (originalMessage.substring(mention.start, mention.end).match(/\n/g) || []).length;

        adjustedStart += newlinesBefore * 2;
        adjustedEnd += (newlinesBefore + newlinesIn) * 2;

        return { ...mention, start: adjustedStart, end: adjustedEnd };
      }

      // Adjust for leading whitespace removal
      let adjustedStart = mention.start - leadingWhitespaceLength;
      let adjustedEnd = mention.end - leadingWhitespaceLength;

      // Adjust for newline conversion (each \n becomes "  \n")
      const newlinesBefore = (originalMessage.substring(0, mention.start).match(/\n/g) || []).length;
      const newlinesIn = (originalMessage.substring(mention.start, mention.end).match(/\n/g) || []).length;

      adjustedStart += newlinesBefore * 2;
      adjustedEnd += (newlinesBefore + newlinesIn) * 2;

      adjustedStart = Math.max(0, adjustedStart);
      adjustedEnd = Math.min(cleanedMessage.length, adjustedEnd);

      // Verify the mention text matches
      const mentionText = cleanedMessage.substring(adjustedStart, adjustedEnd);

      if (mentionText === expectedText) {
        return { ...mention, start: adjustedStart, end: adjustedEnd };
      }

      // Try to find the mention text nearby if it doesn't match
      const searchStart = Math.max(0, adjustedStart - 20);
      const searchEnd = Math.min(cleanedMessage.length, adjustedEnd + 20);
      const searchArea = cleanedMessage.substring(searchStart, searchEnd);
      const foundIndex = searchArea.indexOf(expectedText);

      if (foundIndex !== -1) {
        const newStart = searchStart + foundIndex;
        const newEnd = newStart + expectedText.length;
        return { ...mention, start: newStart, end: newEnd };
      }

      return null;
    })
    .filter((mention): mention is Mention => mention !== null);
};


export const escapeMarkdownNumbers = (markdownContent: string) => {
  return markdownContent.replace(/^(\d+)\./gm, '$1\\.');
}


export const createConversationTitleFromUsersArray = (users: IamData[]) => {
  let conversationName;

  if (users.length <= 2) {
    conversationName = users.map((user: any) => user.firstName + ' ' + user.lastName).join(', ') || DEFAULT_CONVERSATION_NAME;
  } else {
      const firstTwoUsers = users.slice(0, 2).map((user: any) => user.firstName + ' ' + user.lastName).join(', ');
      const remainingCount = users.length - 2;

      conversationName = `${firstTwoUsers}, +${remainingCount}`;
  }

  return conversationName;
}
export interface ParsedContent {
  thinkContent: string;
  responseContent: string;
}

export function parseThinkingContent(content: string): ParsedContent {
  // Input validation
  if (!content) {
    return { thinkContent: '', responseContent: '' };
  }

  // Clean file generation tags first
  content = content
    .replace(/<llm-file-generation-response>/g, '')
    .replace(/<\/llm-file-generation-response>/g, '');

  // Find tag positions
  const openIdx = content.indexOf('<think>');
  const closeIdx = content.indexOf('</think>');

  // No tags present - just return as response
  if (openIdx === -1 && closeIdx === -1) {
    return {
      thinkContent: '',
      responseContent: content.trim()
    };
  }

  // Case 1: Complete block <think>...</think>response
  if (openIdx !== -1 && closeIdx > openIdx) {
    return {
      thinkContent: content.substring(openIdx + 7, closeIdx).trim(),
      responseContent: content.substring(closeIdx + 8).trim()
    };
  }

  // Case 2: Incomplete opening <think>...
  if (openIdx !== -1 && closeIdx === -1) {
    return {
      thinkContent: content.substring(openIdx + 7).trim(),
      responseContent: ''
    };
  }

  // Case 3: Incomplete closing ...</think>response
  if (openIdx === -1 && closeIdx !== -1) {
    return {
      thinkContent: content.substring(0, closeIdx).trim(),
      responseContent: content.substring(closeIdx + 8).trim()
    };
  }

  // Fallback (should never reach here based on our 4 cases)
  return {
    thinkContent: '',
    responseContent: content.trim()
  };
}